
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
  
  {
    path: '/',
    redirect: '/home'
  }, {
    path: '/home',
    name: 'home',
    component: resolve => require(['@/view/HomePage'], resolve),
    meta: {
      title: 'Photon Counting Tech. Ltd.'
    }
  }, {
    path: '/product',
    name: 'product',
    component: resolve => require(['@/view/Product'], resolve),
    children: [
      {
        path: '/product',
        redirect: '/product/ct'
      },
      {
        path: '/product/ct',
        name: 'one',
        component: resolve => require(['@/view/ProductCt'], resolve),
        meta: {
          title: 'Technologies&Solutions'
        }
      },
      {
        path: '/product/food_testing',
        name: 'one',
        component: resolve => require(['@/view/Product1'], resolve),
        meta: {
          title: 'Technologies&Solutions'
        }
      },
      {
        path: '/product/security_check',
        name: 'one',
        component: resolve => require(['@/view/Product2'], resolve),
        meta: {
          title: 'Technologies&Solutions'
        }
      },
      {
        path: '/product/industry',
        name: 'one',
        component: resolve => require(['@/view/Product3'], resolve),
        meta: {
          title: 'Technologies&Solutions'
        }
      },
    ]
  }, {
    path: '/news',
    name: 'news',
    component: resolve => require(['@/view/NewsInformation'], resolve),
    meta: {
      title: 'News'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: resolve => require(['@/view/CompanyIntroduction'], resolve),
    meta: {
      title: 'About'
    }
  },
  {
    path: '/contactus',
    name: 'contactus',
    component: resolve => require(['@/view/ContactUs'], resolve),
    meta: {
      title: 'Contact Us'
    }
  },



]
const router = new VueRouter({
  
  base: process.env.BASE_URL,
  // (缩写) 相当于 routes: routes
  routes
})
export default router